import { Component, input } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { RequisitionStatus } from '@core/requisitions-types';
import { BadgeComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-requisitions-status-badge',
  templateUrl: './requisitions-status-badge.component.html',
  styleUrls: ['./requisitions-status-badge.component.less'],
  imports: [BadgeComponent, TranslatePipe],
})
export class RequisitionsStatusBadgeComponent {
  public readonly status = input<RequisitionStatus>(undefined!);
  public readonly isArchived = input<boolean>(undefined!);
  public RequisitionStatus: typeof RequisitionStatus = RequisitionStatus;
}
